import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, VStack } from '@chakra-ui/react';
import { RequestSidebarFilterForm } from '@src/components/sco/Requests/RequestSidebarFilterForm';
import { SingleRequestSidebarNav } from '@src/components/sco/Requests/SingleRequestSidebarNav';
import { WorkspaceGoalSwitcher } from '@src/components/sco/Requests/WorkspaceGoalSwitcher';
import { SidebarCollapsingNavList } from '@src/components/sco/SidebarCollpasingNavList';
import { GroupRequest } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { ReactNode } from 'react';
import { LuPlus, LuStar, LuTarget } from 'react-icons/lu';
type RequestsNavProps = {
  children?: ReactNode;
  groupRequestId?: any;
  isManagerView?: boolean;
};
export const RequestsNav: React.FC<RequestsNavProps> = props => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    {
      viewer {
        id
        currentUser {
          id
          groupRequests {
            id
            items {
              id
              groupRequestId
              displayTitle
            }
          }
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  if ($[1] !== query.data?.viewer?.currentUser?.groupRequests?.items) {
    t1 = query.data?.viewer?.currentUser?.groupRequests?.items || [];
    $[1] = query.data?.viewer?.currentUser?.groupRequests?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentUserRequests = t1;
  const showWorkspaceGoalSwitcher = !!(props.groupRequestId && props.isManagerView);
  let t2;
  if ($[3] !== currentUserRequests || $[4] !== props.groupRequestId || $[5] !== showWorkspaceGoalSwitcher) {
    t2 = showWorkspaceGoalSwitcher ? <WorkspaceGoalSwitcher groupRequestId={props.groupRequestId} /> : <SidebarCollapsingNavList key={currentUserRequests?.length} collapsed={true} defaultTitle="Browse Requests" items={[{
      title: "My Goals",
      href: "/requests/manage",
      icon: LuTarget,
      items: currentUserRequests?.length > 0 ? currentUserRequests.map(_temp) : null
    }, {
      title: "Add a New Goal",
      href: "/requests/start",
      activeExact: true,
      activePaths: ["/requests/start"],
      icon: LuPlus
    }]} />;
    $[3] = currentUserRequests;
    $[4] = props.groupRequestId;
    $[5] = showWorkspaceGoalSwitcher;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.groupRequestId || $[8] !== props.isManagerView || $[9] !== showWorkspaceGoalSwitcher) {
    t3 = props.groupRequestId ? <SingleRequestSidebarNav groupRequestId={props.groupRequestId} isManagerView={props.isManagerView} showRequestCard={!showWorkspaceGoalSwitcher} /> : <Box paddingY={4}><RequestSidebarFilterForm /></Box>;
    $[7] = props.groupRequestId;
    $[8] = props.isManagerView;
    $[9] = showWorkspaceGoalSwitcher;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <VStack align="stretch" gap={2} height="full" justify="stretch" width="full">{t2}{t3}</VStack>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(request) {
  return {
    title: request.displayTitle,
    href: `/requests/manage/${request.groupRequestId}`,
    icon: LuStar
  };
}